import { axiosInstance, ENDPOINT } from 'common/constants';
import { handleResponse } from 'common/helpers';

import { CSV_TIMEOUT_MS } from './machineCsv.constants';
import { fileNameFromHeader } from './components/MachineCsv/helpers';

export const getCsvCatalog = () =>
  handleResponse(axiosInstance.get(ENDPOINT.GET_MACHINES_CSV_COLUMNS));

const readBlobAsText = blob => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsText(blob);
});

// With responseType 'blob' an error body is a Blob too. Turn it back into the
// JSON the backend sent, so its error_code and message survive.
const withJsonErrorBody = (error) => {
  const data = error && error.response && error.response.data;
  if (!data || typeof Blob === 'undefined' || !(data instanceof Blob)) {
    return Promise.reject(error);
  }
  return readBlobAsText(data).then((text) => {
    try {
      error.response.data = JSON.parse(text);
    } catch (e) {
      error.response.data = {};
    }
    return Promise.reject(error);
  }, () => Promise.reject(error));
};

// Resolves { blob, fileName }; fileName is the backend's, when it sent one.
export const exportMachinesCsv = params =>
  handleResponse(axiosInstance
    .get(ENDPOINT.EXPORT_MACHINES_CSV, { params, responseType: 'blob', timeout: CSV_TIMEOUT_MS.EXPORT })
    .then(response => ({
      data: {
        blob: response.data,
        fileName: fileNameFromHeader(response.headers && response.headers['content-disposition'])
      }
    }), withJsonErrorBody));

export const previewMachinesCsvImport = (file) => {
  const form = new FormData();
  form.append('file', file);
  return handleResponse(axiosInstance.post(ENDPOINT.PREVIEW_MACHINES_CSV_IMPORT, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: CSV_TIMEOUT_MS.PREVIEW
  }));
};

export const applyMachinesCsvImport = changes =>
  handleResponse(axiosInstance.post(
    ENDPOINT.APPLY_MACHINES_CSV_IMPORT,
    { changes },
    { timeout: CSV_TIMEOUT_MS.APPLY }
  ));
